import React from 'react'
import Link from 'gatsby-link'
import jungImg from 'static/jung-thumb.png'
import sungImg from 'static/sung-thumb.png'

const DoctorCard = ({ image, name, title, description, link, linkText }) => (
  <div
    className="flex-1 bg-white rounded-xl overflow-hidden transition-all duration-200 hover:shadow-xl group"
    style={{
      boxShadow:
        '0 7px 14px 0 rgba(50, 50, 93, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07)',
      border: '1px solid #e3e8ee'
    }}
  >
    {/* Card Header with gradient */}
    <div
      className="h-24 relative"
      style={{
        background: 'linear-gradient(135deg, #635bff 0%, #11efe3 100%)'
      }}
    />

    {/* Profile Image - overlapping the header */}
    <div className="flex justify-center -mt-16 relative z-10">
      <img
        className="w-32 h-32 rounded-full border-4 border-white object-cover"
        src={image}
        alt={name}
        style={{
          boxShadow: '0 4px 14px 0 rgba(50, 50, 93, 0.15)'
        }}
      />
    </div>

    {/* Card Content */}
    <div className="p-8 pt-6 text-center">
      <h3 className="text-xl font-semibold text-navy mb-1">{name}</h3>
      <p className="text-sm font-medium mb-4" style={{ color: '#635bff' }}>
        {title}
      </p>
      <p className="text-base text-textSecondary leading-relaxed mb-6">
        {description}
      </p>
      <Link
        className="inline-flex items-center justify-center px-6 py-3 text-sm font-semibold text-primary bg-offWhite rounded-lg transition-all duration-150 hover:bg-grey group-hover:bg-primary group-hover:text-white"
        to={link}
      >
        {linkText}
        <svg
          className="w-4 h-4 ml-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </Link>
    </div>
  </div>
)

const DentistsSection = () => (
  <section className="py-24 px-6 bg-white">
    <div className="container mx-auto">
      {/* Section Header */}
      <div className="text-center mb-16">
        <div
          className="inline-flex items-center px-4 py-2 rounded-full text-xs font-semibold uppercase tracking-wider mb-4"
          style={{
            background:
              'linear-gradient(135deg, rgba(99, 91, 255, 0.1) 0%, rgba(17, 239, 227, 0.1) 100%)',
            color: '#635bff'
          }}
        >
          Our Team
        </div>
        <h2 className="text-4xl font-bold text-navy mb-4">
          Meet Your Dentists
        </h2>
        <p className="text-lg text-textSecondary max-w-2xl mx-auto">
          Our experienced team is dedicated to providing you with the highest
          quality dental care in a comfortable, welcoming environment.
        </p>
      </div>

      {/* Doctor Cards */}
      <div className="flex flex-col md:flex-row gap-8 max-w-4xl mx-auto">
        <DoctorCard
          image={sungImg}
          name="Dr. Sung Yeon Ji"
          title="Doctor of Dental Surgery"
          description="Dr. Sung Yeon Ji (DR. SUNG) received her DDS from New York University College of Dentistry in 2013, bringing years of expertise to our practice."
          link="/about_us#sung"
          linkText="Learn more"
        />

        <DoctorCard
          image={jungImg}
          name="Dr. Jung Hun Ji"
          title="Doctor of Dental Surgery"
          description="Dr. Jung Hun Ji (DR. JI) graduated from Loma Linda University with Doctorate of Dental Surgery in 2014, specializing in comprehensive dental care."
          link="/about_us#jung"
          linkText="Learn more"
        />
      </div>
    </div>
  </section>
)

export default DentistsSection
